export default "__VITE_ASSET__C3HiYE7J__"